
import React from "react";
import { formatDate } from "@/utils/lead-formatter-utils";
import { LeadLocation } from "./LeadLocation";

interface LeadCardFooterProps {
  createdAt: Date | string;
  locationDisplay: string;
}

export const LeadCardFooter = ({ createdAt, locationDisplay }: LeadCardFooterProps) => {
  // Convert string to Date if needed
  const dateObject = typeof createdAt === 'string' ? new Date(createdAt) : createdAt;
  
  return (
    <div className="flex items-center justify-between mt-2 text-xs text-muted-foreground space-x-2">
      <div className="flex items-center max-w-[40%] truncate">
        <span className="truncate">{formatDate(dateObject)}</span>
      </div>
      
      {locationDisplay && (
        <div className="flex items-center justify-end max-w-[60%]">
          <LeadLocation location={locationDisplay} />
        </div>
      )}
    </div>
  );
};

